import React from "react";
import { Tabs, Tab, Box, FormControl, Select, InputLabel, MenuItem } from "@mui/material";
import { styled } from "@mui/system";
import { useTheme } from "@mui/styles";
import { FormattedMessage } from "react-intl";
import useMediaQuery from "@mui/material/useMediaQuery";
import trackEvent from "bundles/common/utils/trackEvent";

const STATS_TAB_KEYS = ["overview", "metrics"];

const StatsTab = ({ selectedStatsTab, setSelectedStatsTab, period, setPeriod }) => {

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const StyledTabs = styled(Tabs)({
    display: "flex",
    justifyContent: "center",
    borderRadius: "12px",
    minHeight: "40px",
    width: isDesktop ? "auto" : "100%",
    backgroundColor: theme.palette.secondary.grey,
    "& .MuiTabs-indicator": {
      display: "none",
    },
    "&.Mui-root": {
      fontSize: "14px !important",
    },
  });

  const StyledTab = styled(Tab)({
    textTransform: "none",
    fontWeight: theme.typography.body1bold.fontWeight,
    color: theme.palette.text.main,
    fontFamily: "Segoe UI Semibold, sans-serif",
    whiteSpace: "nowrap",
    borderRadius: "10px",
    minWidth: "100px",
    width: isDesktop ? "auto" : "50%",
    minHeight: "40px",
    height: "40px",
    "&.Mui-selected": {
      color: "#FFF",
      backgroundColor: "#166D4C",
      padding: "6px 16px !important",
    },
    
  });

  const handleChange = (event, newValue) => {
    setSelectedStatsTab(newValue);
    trackEvent("dashboard", `stats_tab_${STATS_TAB_KEYS[newValue] || newValue}`);
  };

  const handlePeriodChange = (event) => {
    setPeriod(event.target.value);
    trackEvent("dashboard", "period_changed", { period: event.target.value });
  };

  return(
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2, width: "100%", flexWrap: "wrap" }}>
      <Box sx={{display: "inline-block", padding: "4px", borderRadius: "12px", backgroundColor: theme.palette.secondary.grey}}>
        <Box sx={{display: "flex", justifyContent: isDesktop ? "flex-start" : "center", alignItems: "center", width: isDesktop ? "auto" : "100%", fontSize: "14px !important"}}>
          <StyledTabs 
            value={selectedStatsTab} 
            onChange={handleChange}
            aria-label="stats navigation tabs"
            variant="scrollable"
          >
            <StyledTab label={<FormattedMessage id="recruiter.menu.overview" />} />
            <StyledTab label={<FormattedMessage id="recruiter.menu.metrics" />} />
          </StyledTabs>
        </Box>
      </Box>

      {selectedStatsTab === 1 && (
        <FormControl size="small" sx={{ minWidth: 150 }}>
          <InputLabel id="period-select-label">
            <FormattedMessage id="recruiter.metrics.period" defaultMessage="Period" />
          </InputLabel>
          <Select
            labelId="period-select-label"
            id="period-select"
            value={period}
            label={<FormattedMessage id="recruiter.metrics.period" defaultMessage="Period" />}
            onChange={handlePeriodChange}
          >
            <MenuItem value="monthly">
              <FormattedMessage id="recruiter.metrics.monthly" defaultMessage="Monthly" />
            </MenuItem>
            <MenuItem value="quarterly">
              <FormattedMessage id="recruiter.metrics.quarterly" defaultMessage="Quarterly" />
            </MenuItem>
            <MenuItem value="yearly">
              <FormattedMessage id="recruiter.metrics.yearly" defaultMessage="Yearly" />
            </MenuItem>
            <MenuItem value="all">
              <FormattedMessage id="recruiter.metrics.all" defaultMessage="All" />
            </MenuItem>
          </Select>
        </FormControl>
      )}
    </Box>
  );
};

export default StatsTab;